//! @/script/button.js

var text_loading = '<i class="fa fa-spinner fa-spin"></i>',
  text_error = '<i class="fa fa-times"></i>',
  text_ok = '<i class="fa fa-check"></i>';

function buttonLoad(button) {
  let $button = $(button);

  if (!$button.data("loading-text")) {
    $button.data("loading-text", text_loading);
  }

  if (!$button.data("initial-text")) {
    $button.data("initial-text", $button.html());
  }

  $button.addClass("loading");
  $button.prop("disabled", true);
  $button.height($button.height());
  $button.width($button.width());
  $button.html($button.data("loading-text"));
}

function buttonReset(button, done = true, reset = true) {
  let $button = $(button);

  if (!$button.data("loading-text")) {
    $button.data("loading-text", text_loading);
  }

  if (!$button.data("initial-text")) {
    $button.data("initial-text", $button.html());
  }

  done = done === false ? false : true;

  $button.removeClass("loading");
  $button.html(done ? text_ok : text_error);

  if (reset) {
    setTimeout(function () {
      $button.html($button.data("initial-text"));
      $button.prop("disabled", false);
      $button.height("");
      $button.width("");
    }, 500);
  }
}

function goBack() {
  window.location.href = document.referrer ? document.referrer : "/";
}
